import React from "react";
import SearchActionGroup from "container/searchForUser/SearchActionGroup";
import SearchOutfitListPanel from "container/searchForUser/SearchOutfitListPanel";
import GalleryOutfitListPanel from "container/searchForUser/GalleryOutfitListPanel";
import { withStore } from "store/storeHandler";
import { withToken } from "lib/forceTokenRenewComponent";
import PropTypes from "prop-types";

RootSearchForUser.propTypes = {
  searchQry: PropTypes.shape({
    category: PropTypes.string,
    tag: PropTypes.string,
    color: PropTypes.string,
    brand: PropTypes.string,
    gender: PropTypes.string
  }).isRequired
};

function RootSearchForUser(props) {
  const { searchQry, SearchActions, AppErrorActions } = props;
  const { getIdTokenWT } = props;

  const listMode =
    searchQry.category && searchQry.gender ? "SEARCH_MODE" : "GALLERY_MODE";

  const getNewSearchList = async query => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;

    const { category, brand, color, tag, gender } = query;
    try {
      await SearchActions.changeListType({
        idToken,
        category,
        brand,
        color,
        tag,
        gender
      });
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const getSearchList = async () => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;

    try {
      await SearchActions.getList({ idToken });
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const clearSearchList = () => {
    SearchActions.clearExportedSearchData();
  };

  return (
    <div>
      <SearchActionGroup
        category={searchQry.category}
        tag={searchQry.tag}
        color={searchQry.color}
        brand={searchQry.brand}
        gender={searchQry.gender}
        getNewList={getNewSearchList}
        clearSearchList={clearSearchList}
      />
      {listMode === "SEARCH_MODE" && (
        <SearchOutfitListPanel getList={getSearchList} />
      )}
      {listMode === "GALLERY_MODE" && <GalleryOutfitListPanel />}
    </div>
  );
}

export default withStore({
  dispatchMap: ["search", "appError"]
})(withToken(RootSearchForUser));
